// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__nrOuv","validationTips":"StatementDescriptor_validationTips__1zDQq"};